<template>
    <div>
        <h1 class="h3 mb-3 text-gray-800">{{ $t(titulo) }}</h1>
        <loading-animation
            :active.sync="loading"
            :is-full-page="false"
            :opacity="1"
            color="#5895FF"
        />
        <form
            @submit.prevent="submit"
            ref="addItem"
            v-if="adolescentes.length > 0"
        >
            <!--Bloco Responsável Familiar-->
            <div class="row">
                <form-select
                    v-model="medidas.usuario_id"
                    label="Adolescente"
                    :itens="adolescentes"
                    :required="true"
                />

                <form-select
                    v-model="medidas.tipo_id"
                    label="Tipo"
                    :required="true"
                    :itens="tipos"
                />
                <form-calendar
                    v-model="medidas.processo_data_inicial"
                    grid="4"
                    label="Data de início"
                    :required="true"
                />
                <form-calendar
                    v-model="medidas.processo_data_final"
                    grid="4"
                    label="Data Final"
                />
                <form-input
                    v-model="medidas.numero_processo"
                    grid="4"
                    label="Número do Processo"
                />
                <form-toggle
                    class="d-flex justify-content-start"
                    mt="0"
                    v-model="medidas.acomp_creas"
                    label="Está em acompanhamento?"
                />
            </div>
            <div class="row" v-if="medidas.acomp_creas == 1">
                <form-select
                    :disabled="medidas.acomp_creas == 1 ? false : true"
                    v-model="medidas.acomp_creas_unidade_id"
                    label="Unidade"
                    :itens="unidades"
                    grid="6"
                    @selected="searchTecnicos"
                />

                <form-select
                    :disabled="medidas.acomp_creas == 1 ? false : true"
                    v-model="medidas.orientador_social"
                    label="Orientador Social"
                    :loading="loadingTecnicos"
                    :itens="tecnicos"
                    grid="6"
                />
                <form-calendar
                    :disabled="medidas.acomp_creas == 1 ? false : true"
                    v-model="medidas.acomp_data_inicial"
                    grid="6"
                    label="Data de início"
                />
                <form-calendar
                    :disabled="medidas.acomp_creas == 1 ? false : true"
                    v-model="medidas.acomp_data_final"
                    grid="6"
                    label="Data Final"
                />
            </div>

            <search-tecnico :tecnicos.sync="medidas.tecnicos" />
            <div class="row">
                <form-textarea-editor
                    v-model="medidas.observacoes_medida"
                    label="Observação sobre o cumprimento da medida"
                    :required="true"
                />
                <form-file
                    @submit="submitFile"
                    multiple
                    btn-text="Iniciar"
                    :progress="progressCompleted"
                />
            </div>
            <div class="row pt-4 px-0 d-flex justify-content-end">
                <form-toggle
                    grid="9"
                    class="d-flex justify-content-end"
                    mt="0"
                    v-model="medidas.privado"
                    label="Sigilo?"
                />

                <div class="col-auto px-2 text-right">
                    <a class="btn btn-default" @click="$emit('voltar')">
                        <i class="mdi mdi-arrow-left" />
                    </a>
                    <button
                        class="btn btn-success btn-submit"
                        data-style="zoom-in"
                        type="submit"
                    >
                        <i class="mdi mdi-content-save" />
                        {{ $t("Salvar") }}
                    </button>
                </div>
            </div>
        </form>
        <div class="row" v-else>
            <div class="col-12">
                <div class="alert alert-info bg-gradient-info">
                    O grupo familiar não tem na sua composição adolescente com
                    idade para cumprimento de medida socioeducativa.
                </div>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props: ["familia"],
    name: "Add",
    data() {
        return {
            medidas: {
                acomp_creas: 0,
                privado: false,
                tecnicos: [],
            },
            adolescentes: [],
            tecnicos: [],
            unidades: [],
            tipos: [],
            servicos: [],
            files: [],
            progressCompleted: 0,
            titulo: "Registro de Medida Socioeducativa",
            loading: true,
            loadingTecnicos: false,
        };
    },
    mounted() {
        this.getCamposmedida();
        // this.privateFromOsasco();
        // this.getTecnicos();
        // this.getTipos();
        // this.getUnidades();
    },
    methods: {
        // privateFromOsasco() {
        //   const role_name = this.$store.state.user.role_details.name;
        
        //     if (window.location.hostname == "osascosp.suasfacil.com.br" || window.location.hostname == 'suasfacil.host'|| window.location.hostname == 'sandbox.suasfacil.com.br' && role_name == 'Técnico(a) de Nível Superior') {
        //         this.medidas.privado =  1;
        //     } else {
        //         this.medidas.privado =  2;
        //     }
        // },
        getCamposmedida() {
            axios
                .get(`api/dashboard/medidas/get/campos/${this.familia.id}`)
                .then((response) => {
                    this.adolescentes = response.data.adolescentes;
                    this.tipos = response.data.tipos;
                    this.unidades = response.data.unidades;
                })
                .finally(() => {
                    this.loading = false;
                });
        },
        // getAdolescentes() {
        //     axios
        //         .get(
        //             `api/dashboard/medidas/adolescentes/get/${this.familia.id}`
        //         )
        //         .then((response) => {
        //             this.adolescentes = response.data;
        //         })
        //         .finally(() => (this.loading = false));
        // },
        searchTecnicos() {
            this.tecnicos = [];
            this.loadingTecnicos = true;

            axios
                .get(
                    `api/dashboard/tecnicos/get/externos/${this.medidas.acomp_creas_unidade_id}`
                )
                .then((response) => {
                    this.tecnicos = response.data;
                })
                .finally(() => {
                    this.loadingTecnicos = false;
                });
        },
        getTecnicos() {
            axios.get(`api/dashboard/tecnicos/get`).then((response) => {
                this.tecnicos = response.data;
            });
        },
        // getTipos() {
        //     axios.get(`api/dashboard/tipos/medidas`).then((response) => {
        //         this.tipos = response.data;
        //     });
        // },
        // getUnidades() {
        //     axios
        //         .get(`api/dashboard/unidades/get/externas/medidas`)
        //         .then((response) => {
        //             this.unidades = response.data;
        //         });
        // },
        submitFile(files) {
            this.files = files;
        },
        submit() {
            this.medidas.familia_id = this.$route.params.id;
            this.$route.query.familia_id = this.$route.params.id;
            let formData = new FormData();
            if (this.files.length > 0 && this.files.length != undefined) {
                for (const i of Object.keys(this.files)) {
                    formData.append("anexos[]", this.files[i]);
                }
            } else {
                formData.append("anexos", this.files);
            }
            
            for (var key in this.medidas) {
                formData.append(key, this.medidas[key]);
            }
            let ladda = Ladda.create(document.querySelector(".btn-submit"));
            ladda.start();
            axios
                .post(`api/dashboard/medidas`, formData, {
                    header: { "Content-Type": "multipart/form-data" },
                    onUploadProgress: (event) => {
                        let progress = Math.round(
                            (event.loaded * 100) / event.total
                        );
                        this.progressCompleted = progress;
                    },
                })
                .then((response) => {
                    ladda.stop();
                    this.$snack.success({
                        button: false,
                        text: "Medida cadastrada com sucesso.",
                    });
                    this.$router.push(
                        `/dashboard/medida/edit/${response.data.id}`
                    );
                })
                .finally(() => {
                    this.progressCompleted = 0;
                    this.files = [];
                });
        },
    },
};
</script>
